import React from 'react';
import { Link } from 'react-router-dom';
import pageAssets from '../../../../data/pageAssets';
import { openQuoteChat } from '../../../../utils/site';
import AppImage from '../../../common/media/AppImage';

const WiresHeroSection = ({ hero }) => {
    const handlePrimaryClick = (e) => {
        if (hero.primaryCtaRoute?.includes('#')) {
            e.preventDefault();
            const id = hero.primaryCtaRoute.split('#')[1];
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
    <section id="home" className="about-wires-hero">
        <div className="container">
            <div className="about-wires-hero-grid">
                <div className="about-wires-hero-content">
                    <div className="about-wires-hero-badge">{hero.badge}</div>
                    <h1 className="about-wires-hero-title">
                        {hero.titleLine1} <span>&</span><br />
                        <span>{hero.titleLine2}</span>
                    </h1>
                    <p className="about-wires-hero-description">{hero.description}</p>
                    <div style={{ display: 'flex', gap: 'var(--space-4)', flexWrap: 'wrap' }}>
                        <Link to={hero.primaryCtaRoute} className="btn btn-primary btn-lg" onClick={handlePrimaryClick}>{hero.primaryCtaLabel}</Link>
                        <button type="button" className="btn btn-lg about-wires-hero-ghost-btn" onClick={openQuoteChat}>
                            {hero.secondaryCtaLabel}
                        </button>
                    </div>
                </div>
                <div className="about-wires-hero-image">
                    <AppImage src={pageAssets[hero.imageKey]} alt={hero.imageAlt} priority />
                </div>
            </div>
        </div>
    </section>
    );
};

export default WiresHeroSection;
